export default __webpack_public_path__ + "static/media/alex11.afeabaff.jpg";